exports["BG"] = require("./BG.js");
exports["RU"] = require("./RU.js");
exports["AU"] = require("./AU.js");
exports["UA"] = require("./UA.js");
exports["BA"] = require("./BA.js");
exports["HU"] = require("./HU.js");
exports["AT"] = require("./AT.js");
exports["AM"] = require("./AM.js");
exports["GE"] = require("./GE.js");
exports["LT"] = require("./LT.js");
exports["PL"] = require("./PL.js");
exports["CZ"] = require("./CZ.js");